import { ReactNode } from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useCenteredPageLayoutStyles } from './CenteredPageLayout.styles';

interface CenteredPageLayoutProps {
  children?: ReactNode
  className?: string
}

const CenteredPageLayout: React.FC<CenteredPageLayoutProps> = (props: CenteredPageLayoutProps) => {
  const { children, className } = props;
  const styles = useCenteredPageLayoutStyles();
  const testId = 'centered-page-layout';

  return (
    <div className={mergeClasses(testId, styles.container, className)} data-testid={testId}>
      {children}
    </div>
  );
};

export default CenteredPageLayout;
